import {
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from '@angular/core'
import { NzModalModule } from 'ng-zorro-antd/modal'
import { LoginNoRoleComponent } from '../../../../pages/auth/components/login-no-role/login-no-role.component'

@Component({
  selector: 'aiomed-no-role-selected',
  templateUrl: './no-role-selected.component.html',
  styleUrls: ['./no-role-selected.component.scss'],
  imports: [NzModalModule, LoginNoRoleComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoRoleSelectedComponent {
  readonly isVisible = input<boolean>(false)
  readonly hasYesDisabled = input<boolean>(false)
  readonly isMatrixCare = input.required<boolean>()
  readonly yesClicked = output<void>()
  readonly noClicked = output<void>()
}
